import { HTMLProps, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { SELECTED_FUND_COLORS } from '../../../config/constants';
import { useWindowBreakpoints } from '../../../hooks/useWindowBreakpoints';
import { IntermediateFundsSelectionContext } from './FundsSelectionScreen';
import { Button } from '../../general/Button';

export const FundsSelectionSticky: React.FC<{} & HTMLProps<HTMLDivElement>> = ({ className, ...rest }) => {
    const history = useHistory();
    const fundsContext = useContext(IntermediateFundsSelectionContext);
    const { t } = useTranslation('funds');
    const { isMobile } = useWindowBreakpoints();

    return (
        <div
            id="funds-selection-sticky"
            className={`sticky p-4 flex flex-row justify-end w-full bottom-10 pointer-events-none ${className}`}
            {...rest}
        >
            <div
                className={`bg-white rounded-lg shadow-lg pointer-events-auto transition overflow-hidden ${
                    fundsContext.funds.selected.length > 0 ? 'opacity-100' : 'opacity-0'
                }`}
                style={{ minWidth: '250px' }}
            >
                {fundsContext.funds.selected.length > 1 && (
                    <div className="flex justify-between items-center py-2 px-4 bg-gray-50">
                        <div></div>
                        <div>
                            <Button
                                id="remove-all-funds"
                                className="text-sm"
                                buttonType="internalLinkGreen"
                                onClick={() => {
                                    fundsContext.funds.set([]);
                                }}
                            >
                                {t('funds-selection-screen-sticky-delete-all')}
                            </Button>
                        </div>
                    </div>
                )}
                {fundsContext.funds.selected.map((fund, index) => {
                    return (
                        <div
                            data-fund-id={fund.id}
                            className={`${fundsContext.funds.selected.length > 1 && 'border-t border-gray-300'}
                                    flex justify-between items-center py-2 px-2 sm:py-6 sm:px-6 `}
                            key={index}
                        >
                            <div className="flex items-center">
                                <div className="mr-4">
                                    <div
                                        className="rounded-full w-3 h-3"
                                        style={{ backgroundColor: SELECTED_FUND_COLORS[index] }}
                                    ></div>
                                </div>
                                <div className={`text-sm sm:text-lg`}>{fund.name}</div>
                            </div>
                            <Button
                                id={'remove-fund'}
                                buttonType="internalLinkGreen"
                                className="ml-3 sm:ml-8"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    fundsContext.funds.remove(fund);
                                }}
                            >
                                {isMobile ? 'x' : t('funds-selection-screen-sticky-delete')}
                            </Button>
                        </div>
                    );
                })}
                <Button
                    id="show-selection"
                    buttonType="primary"
                    className="px-8 w-full"
                    onClick={() => {
                        const element = document.getElementsByTagName('funds-robot')[0];
                        element?.scrollIntoView(true);
                        history.push('/comparison');
                    }}
                >
                    {fundsContext.funds.selected.length > 1
                        ? `${t('funds-selection-screen-compare-button')}`
                        : `${t('funds-selection-screen-select-button')}`}
                </Button>
            </div>
        </div>
    );
};
